// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-4[data-v-634c7c5a]{gap:16px}", ""]);
// Exports
module.exports = exports;
